import { PropertiesWidget } from "./properties.mjs"
import "tripartite"

import SimpleBackgroundParallax from 'simple-background-parallax'

let sbp = new SimpleBackgroundParallax('.moving-back picture:first-child img')
sbp.start()

function create(html) {
	let parent = document.createElement('div')
	parent.innerHTML = html
	return parent.firstElementChild
}

let shinerShows = document.querySelectorAll('.shiner-show')
if (shinerShows.length > 0) {
	const Shiner = (await import("@webhandle/shiner")).Shiner
	shinerShows.forEach(show => {
		let shiner = new Shiner({
			el: show
		})
		shiner.render()
		if (show.classList.contains('auto-play')) {
			shiner.run()
		}
	})

}

let propertiesWidgetEl = document.querySelector('#properties-widget')
if (propertiesWidgetEl) {
	let propertiesWidget = new PropertiesWidget({
		properties: window.properties
	})
	propertiesWidget.render()
	propertiesWidget.appendTo(propertiesWidgetEl)

}



let header = document.querySelector('header');

function adjustHeaderStyle() {
	if (window.scrollY > 0) {
		header.classList.add('scrolled');
	} else {
		header.classList.remove('scrolled');
	}
}

window.addEventListener('scroll', adjustHeaderStyle)
adjustHeaderStyle()



let people = document.querySelector('.people')
let peopleRect
let movingPeople = false
if (people) {
	peopleRect = people.getBoundingClientRect()
	if (peopleRect.width === 1400) {
		movingPeople = true
	}
}

let persons = document.querySelectorAll('.people .person')
let locations = []
for (let person of persons) {
	person.addEventListener('click', async (evt) => {
		let personHtml = person.parentElement.innerHTML
		let template = await tripartite.loadTemplateAsync('person-dialog')

		let dialogHtml = template(personHtml)
		let dialog = create(dialogHtml)

		dialog.querySelector('.close-button').addEventListener('click', (evt) => {
			dialog.close()
		})

		document.body.appendChild(dialog)
		dialog.showModal()
	})
}


let propertyImages = document.querySelectorAll('.property-image')
async function makePropertyImagesLightbox() {
	let pics = []
	for (let pi of propertyImages) {
		pics.push(pi.innerHTML)
	}

	let template = await tripartite.loadTemplateAsync('lightbox-dialog')

	let dialogHtml = template(pics)
	let dialog = create(dialogHtml)

	dialog.querySelector('.close-button').addEventListener('click', (evt) => {
		dialog.close()
	})

	document.body.appendChild(dialog)
	dialog.showModal()
	const Shiner = (await import("@webhandle/shiner")).Shiner
	let show = dialog.querySelector('.shiner-show')

	let shiner = new Shiner({
		el: show
	})
	shiner.render()
	if (show.classList.contains('auto-play')) {
		shiner.run()
	}
}

if (propertyImages.length > 0) {
	for (let pi of propertyImages) {
		if (pi.classList.contains('dot')) {
			pi.addEventListener('click', makePropertyImagesLightbox)
		}
		else {
			let img = pi.querySelector('img')
			img.addEventListener('click', makePropertyImagesLightbox)
		}
	}

}

let propertySlideshow = document.querySelector('.property-slideshow .slide')
if (propertySlideshow) {
	propertySlideshow.addEventListener('click', (evt) => {
		makePropertyImagesLightbox()

		// if(evt.target.tagName == 'IMG') {
		// 	makePropertyImagesLightbox()
		// }
	})
}

let openers = document.querySelectorAll('.webhandle-menu-loader-tribar, .mobile-menu .close')
for (let opener of openers) {

	opener.addEventListener('click', (evt) => {
		evt.preventDefault()
		document.body.classList.toggle('menu-open')
	})
}

let newsSearchForm = document.querySelector('#search-news-form')
if (newsSearchForm) {
	let textSearch = newsSearchForm.querySelector('input[name="search"]')
	let categories = newsSearchForm.querySelector('select[name="categories"]')
	let dateRange = newsSearchForm.querySelector('select[name="dateRange"]')
	newsSearchForm.addEventListener('submit', (evt) => {
		evt.preventDefault()
	})

	function filterNews() {
		let articles = [...document.querySelectorAll('.news-article-summary')]
		for (let article of articles) {
			article.classList.remove('hidden')
		}
		if (textSearch.value) {
			for (let article of articles) {
				let txt = article.innerHTML.toLowerCase()
				if (txt.indexOf(textSearch.value.toLowerCase()) < 0) {
					article.classList.add('hidden')
				}
			}
		}
		if (categories.value) {
			for (let article of articles) {
				let txt = article.getAttribute('data-categories')
				if (txt.indexOf(categories.value) < 0) {
					article.classList.add('hidden')
				}
			}
		}
		if (dateRange.value) {
			for (let article of articles) {
				let txt = article.getAttribute('data-date')
				if (txt.indexOf(dateRange.value) < 0) {
					article.classList.add('hidden')
				}
			}
		}

	}

	textSearch.addEventListener('keyup', filterNews)
	categories.addEventListener('change', filterNews)
	dateRange.addEventListener('change', filterNews)

}

let transitionSize = 650
let headerVideo = document.querySelector('#realestate-header-video')
if (headerVideo) {
	function chooseVideo() {
		let width = window.innerWidth
		
		let src 
		if (width > transitionSize) {
			src = "/vid/realestate-header-desktop.mp4"
		}
		else {
			src = "/vid/realestate-header-mobile.mp4"
		}
		if(headerVideo.getAttribute('src') != src) {
			headerVideo.pause()
			headerVideo.currentTime = 0
			headerVideo.setAttribute('src', src)
			headerVideo.load()
		}
	}
	window.addEventListener('resize', chooseVideo)
	chooseVideo()
}

let propertyHeaderVideo = document.querySelector('#property-header-video')
if (propertyHeaderVideo) {
	function chooseVideo() {
		let width = window.innerWidth
		
		let src
		if (width > transitionSize) {
			src = "/vid/property-header-desktop.mp4"
		}
		else {
			src = "/vid/property-header-mobile.mp4"
		}

		if(propertyHeaderVideo.getAttribute('src') != src) {
			propertyHeaderVideo.pause()
			propertyHeaderVideo.currentTime = 0
			propertyHeaderVideo.setAttribute('src', src)
			propertyHeaderVideo.load();
		}
	}
	window.addEventListener('resize', chooseVideo)
	chooseVideo()
}